import React from 'react';
import { motion } from 'framer-motion';

export default function ReviewCard({ author, content }) {
  return (
    <motion.div
      className='p-4 bg-white rounded-2xl shadow-md hover:shadow-lg transition'
      whileHover={{ scale: 1.03 }}
    >
      <p className='text-gray-700 italic'>"{content}"</p>
      <p className='text-sm text-gray-500 text-right mt-2'>
        — {author || 'Anonymous'}
      </p>
    </motion.div>
  );
}
